import React from 'react';
import { __ } from 'i18n/index';
import MatchStatusLine from 'react/match/status/MatchStatusLine';

const INTERACTIVE = 'a, button, input, select, textarea, label';

// The 60px bar at the bottom of every page while the user has a current
// match: the match status line, fixed to the viewport. Clicking the bar or
// its caret opens the sheet (sheet: { isOpen, canOpen, open, close }), where
// the page has one. On phones its action area is a link to the match instead.
// chatControl: the dock's Chat control, beside the caret.
export default function MatchDockBar({ match, matchHref, onOpenPanel, sheet, chatControl = null }) {
	const openFromBar = (event) => {
		if(!sheet.canOpen || sheet.isOpen || event.target.closest(INTERACTIVE)) {
			return;
		}
		sheet.open();
	};
	return (
		<section
			className={'match-dock-bar' + (sheet.canOpen ? ' match-dock-bar--opens' : '')}
			role='region'
			aria-label={__('Your match')}
			onClick={openFromBar}
		>
			<MatchStatusLine match={match} panelHref={matchHref} onOpenPanel={onOpenPanel} className='match-dock-bar__line' />
			{(sheet.canOpen || chatControl) && (
				<div className='match-dock-bar__dock'>
					{chatControl}
					{sheet.canOpen && (
						<button
							type='button'
							className='match-dock-bar__caret'
							aria-expanded={sheet.isOpen}
							aria-label={sheet.isOpen ? __('Close match panel') : __('Open match panel')}
							onClick={sheet.isOpen ? sheet.close : sheet.open}
						>
							<span aria-hidden='true'>{sheet.isOpen ? '▼' : '▲'}</span>
						</button>
					)}
				</div>
			)}
			<a className='match-dock-bar__phone-link' href={matchHref}>
				{__('Open match')}
			</a>
		</section>
	);
}
